module.exports = __webpack_public_path__ + "static/media/gb.5df060a0.svg";